import { toMe } from "domain/models/me";

import { useGetMe, useGetMeHook } from "apiClients/apiPatient";

export const useMe = () => useGetMe({ query: { select: toMe } });

export const useMeHook = () => {
  const hook = useGetMeHook();
  return async (signal?: AbortSignal) => toMe(await hook(signal));
};
